import useFleetExecutions from "../../hooks/useFleetExecutions";
import SimpleLoader from "../Loader/SimpleLoader";
import UpdateIcon from '../icons/update_icon'
import ModalPortal from '../Modal'
import ModalFleetExecutionTask from '../Modal/ModalFleetExecutionTask'
import FilterFleetExecutions from "./FiltersFleetExecutions";
import HeaderFleetExecutionsTable from "./HeaderFleetExecutionsTable";
import React from "react";
import FleetExecution from "./FleetExecution";
import usePopUp from "../../hooks/usePopUp";
import ModalAbortExecution from '../Modal/ModalAbortExecution'
import ModalRedriveExecution from '../Modal/ModalRedriveExecution'

export default function TableFleetExecutions({ fleet_execution_id = '' }){
  const { loading, tFleetExecutions, viewCancelPopUp, viewRedrivePopUp, refreshTables } = useFleetExecutions(fleet_execution_id || undefined);
  const {viewPopUp, handdleViewPopUp} = usePopUp()

  const RenderSingleFleetExecution = (executionId: string) => {
    const expandRows = (executionId.length > 0);
    const execution_elem = tFleetExecutions

    return (
      <>
        <HeaderFleetExecutionsTable />
          {
            execution_elem.map((execution:any, index: number) => {
              return(
                <React.Fragment key={`${execution.fleet_execution_id}${index}`}>
                  <FleetExecution execution={execution} expandRows={expandRows} handdleViewPopUp={handdleViewPopUp}/>
                </React.Fragment>
              )
            })
          }
      </>
    )
  }

  return (
    <>
      <div className='refresh-button' onClick={refreshTables}>
        {loading? (<SimpleLoader />) : (<UpdateIcon width='18px' height='18px' />)}
        <p>Refresh</p>
      </div>

      {
        viewCancelPopUp &&
        <ModalPortal>
          <ModalAbortExecution />
        </ModalPortal>
      }

      {
        viewRedrivePopUp &&
        <ModalPortal>
          <ModalRedriveExecution />
        </ModalPortal>
      }

      {
        viewPopUp.view && viewPopUp.data &&
        <ModalPortal>
          <ModalFleetExecutionTask viewPopUp={viewPopUp} handdleViewPopUp={handdleViewPopUp}/>
        </ModalPortal>
      }

      <FilterFleetExecutions />

      <section>
        {tFleetExecutions && tFleetExecutions.length !== 0 ? (
          RenderSingleFleetExecution(fleet_execution_id)
        ) : loading? (<></>) : (
          <p className="p-table-msg">No data</p>
        )}
      </section>
    </>
  );
};


